<template>
    <div class="wapper">
        <el-page-header @back="goBack" content="提成方案详情" class="header">   
        </el-page-header>
        <div class="content-wapper" v-if="null != info">
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>方案编号</label>
                        <span>{{info.commissionCode}}</span>
                    </div>
                    <div>
                        <label>方案状态</label>
                        <span>{{info.state ? '已开启':'已关闭'}}</span>
                    </div>
                    <div>
                        <label>方案名称</label>
                        <span>{{info.commissionName}}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>方案类型</label>
                        <span>{{ info.jcCategoryName }}</span>
                    </div>
                    <div>
                        <label>方案标签</label>
                        <span>{{ info.tagName }}</span>
                    </div>
                    <div>
                        <label>销售提成</label>
                        <span>{{info.saleCommission }}%</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>经理提成</label>
                        <span>{{info.managerCommission}}%</span>
                    </div>
                    <div>
                        <label>总监提成</label>
                        <span>{{info.directorCommission}}%</span>
                    </div>
                    <div>
                        <label>总经理提成</label>
                        <span>{{info.generalManagerCommission}}%</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>创建人</label>
                        <span>{{info.creatorName}}</span>
                    </div>
                    <div>
                        <label>创建时间</label>
                        <span>{{info.gmtCreate}}</span>
                    </div>
                    <div>
                        <label>单点售价区间</label>
                        <span>{{info.minUnitPrice}} - {{ info.maxUnitPrice }}</span>
                    </div>
                </li>
                <li>
                    <div class="special">
                        <label>备注说明</label>
                        <span class="textarea">{{info.remarks}}</span>
                    </div>
                </li>
               
            </ul>
        </div>
    </div>
</template>

<script>
    import _purchasePlan from '@/service/purchase-plan-service'
    export default {
        data() {
            return {
                id: this.$route.query.id,
                info:  null,
            }
        },
        mounted () {
            // 查询信息
            let _loading = this.$loading({ fullscreen: true })
            _purchasePlan.royaltyPlanDetalis(this.id, response => {
                _loading.close()
                this.info = response
            })
        },
        methods: {
            goBack () {
                this.$router.back()
            }
        }
    }
</script>

<style scoped>
.wapper {
    padding: 15px;
}
.header{
    margin-bottom: 15px;
}
.content-wapper{
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 30px;
    padding-top: 15px;
    background: #fff;
}
.info-wapper li{
    margin: 15px 0;
}
.info-wapper div{
    display: inline-block;
    width: 30%;
    position: relative;
    margin-right: 1%;
}
.info-wapper .special{
    width: 800px;
}
.info-wapper span {
    margin-left: 130px;
}
.info-wapper label{
    color: #909399;
    display: inline-block;
    width: 100px;
    text-align: right;
    position: absolute;
    top: 0;
}
.textarea{
    display: inline-block;
    width: 500px;
}
</style>